import React from 'react';
import PropTypes from 'prop-types';
import { ContentCard } from '@/pages/inside/tenant/style';

import UserAvatar from '@/components/ui/UserAvatar';

const TeamActivityCard = ({ activities, onSeeMore, title = 'Team Activity' }) => {
    const list = activities && activities.length > 0 ? activities : [];

    return (
        <ContentCard $padding="24px" style={{ height: '100%', minHeight: 280 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0 0 20px 0' }}>
                <h3 style={{ fontSize: 16, fontWeight: 600, color: 'var(--ant-color-text, #111827)', margin: 0, fontFamily: 'var(--font-family-geist)' }}>
                    {title}
                </h3>
                {list.length > 0 && onSeeMore && (
                    <button
                        type="button"
                        onClick={onSeeMore}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            color: 'var(--ant-color-primary, #7543DC)',
                            fontSize: 13,
                            fontWeight: 600,
                            cursor: 'pointer',
                            padding: '4px 8px',
                            borderRadius: 6,
                            transition: 'all 0.2s ease',
                            fontFamily: 'var(--font-family-geist)',
                            display: 'inline-flex',
                            alignItems: 'center',
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.background = 'rgba(117, 67, 220, 0.08)';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.background = 'transparent';
                        }}
                    >
                        See More
                    </button>
                )}
            </div>
            {list.length === 0 ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 150, color: 'var(--ant-color-text-secondary, #6b7280)', fontSize: 14, fontWeight: 500 }}>
                    N/A
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    {list.map((item) => (
                        <div key={item.id} style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                            <UserAvatar
                                name={item.user}
                                role={item.role}
                                imageUrl={item.imageUrl}
                                initials={item.initials || (item.user ? item.user.charAt(0) : 'U')}
                                avatarBg={item.avatarBg}
                                disableExpand={true}
                            />
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <div style={{ fontSize: 13, color: 'var(--ant-color-text, #111827)', lineHeight: '18px' }}>
                                    <span style={{ fontWeight: 600 }}>{item.user}</span> {item.action}
                                </div>
                                <span style={{ fontSize: 11, color: 'var(--ant-color-text-secondary, #6b7280)' }}>
                                    {item.time}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </ContentCard>
    );
};

TeamActivityCard.propTypes = {
    activities: PropTypes.array,
    onSeeMore: PropTypes.func,
    title: PropTypes.string,
};

export default TeamActivityCard;

